import { userForgetPasswordSuccess, userForgetPasswordError, userChangePasswordSuccess, userChangePasswordError } from "./reducer";

import {
	postForgetPwd,
	postPasswordChange
} from "../../../helpers/backend_helper";
import { toast } from "react-toastify";
import {checkMaintenance} from '../login/helper';

/**
 * Thunk function for initiating the forgot password process.
 * Dispatches actions based on the success or failure of the process.
 * @param {Object} user - The user object containing necessary information (e.g., email).
 * @param {Function} navigate - The function to navigate to a different route in the application.
 * @param {Function} dispatch - The Redux dispatch function.
 * @throws {Error} If there is an error during the forgot password process.
 */
export const userForgetPassword = (user, navigate) => async (dispatch, getState) => {
	const {language} = getState().MenuData;
	try {
		let response = await postForgetPwd({ email: user.email });
		dispatch(userForgetPasswordSuccess(language[response.code]));
		dispatch(userForgetPasswordError(null));
		if (response.status === 'ok') {
			// navigate(`/new-password?token=${response.data.token}`);
		} else {
			throw response;
		}
	} catch (err) {
		checkMaintenance(dispatch, err);
		toast.error(language[err?.code], { autoClose: 3000 });
		// dispatch(userForgetPasswordError(err));
		// dispatch(userForgetPasswordSuccess(null));
	}
};

/**
 * Thunk function for initiating the user password change process.
 * Dispatches actions based on the success or failure of the process.
 * @param {string} pwd - The new password to be set.
 * @param {Object} params - Additional parameters needed for the password change process.
 * @param {Function} navigate - The function to navigate to a different route in the application.
 * @param {Function} dispatch - The Redux dispatch function.
 * @throws {Error} If there is an error during the password change process.
 */
export const userChangePassword = (pwd, navigate) => async (dispatch, getState) => {
	const {language} = getState().MenuData;
	try {
		const { createPasswordToken, isInvite, invitorUser, isAdmin, faf } = getState().ForgetPassword;
		let response = await postPasswordChange({
			...pwd,
			isInvite: isInvite,
			invitorUser: invitorUser,
			isAdmin: isAdmin,
			faf: faf
		},
			{
				reset_token: createPasswordToken
			});
		dispatch(userChangePasswordSuccess(language[response.code]));
		dispatch(userChangePasswordError(null));
		// console.log(response);
		if (response.status === 'ok') {
			navigate("/success", { state: language[response.code] });
		} else {
			throw response;
		}
	} catch (error) {
		checkMaintenance(dispatch, error);
		dispatch(userChangePasswordError(language[error.code]));
		dispatch(userChangePasswordSuccess(null));
	}
};